// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__LP1L7","textForm":"Form_textForm__qvTns","button":"Form_button__3iu5M","buttonArea":"Form_buttonArea__1fEgj"};